module.exports = __webpack_public_path__ + "static/media/banner-8.f98ca063.jpg";